import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: none;

  @media screen and (min-width: 768px) {
    display: flex;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    padding: 16px;
    z-index: 1;
    transform: translate(0, -50%);
    justify-content: space-between;
    pointer-events: none;
  }
`;

export const Button = styled.button`
  display: grid;
  place-content: center;
  width: 32px;
  aspect-ratio: 1;
  border: none;
  border-radius: 50%;
  z-index: 10;
  color: currentColor;
  background-color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  pointer-events: all;

  &:hover {
    background-color: #fff;
  }

  &:first-child > * {
    transform: translate(-3%, 0);
  }

  &:last-child > * {
    transform: translate(3%, 0);
  }
`;
